// ============================================
// 上岸小搭子 - 底部导航栏组件
// ============================================

import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import './TabBar.scss';

interface TabItem {
  path: string;
  label: string;
  icon: string;
}

const tabs: TabItem[] = [
  { path: '/practice', label: '刷题', icon: '🔥' },
  { path: '/today', label: '今日', icon: '📅' },
  { path: '/ai-chat', label: '智学', icon: '🤖' },
  { path: '/course', label: '课程', icon: '📺' },
  { path: '/profile', label: '我的', icon: '👤' },
];

const TabBar: React.FC = () => {
  const location = useLocation();

  // 判断当前是否在课程页
  const isCourseActive = location.pathname.startsWith('/course');

  return (
    <div className="tab-bar">
      {tabs.map((tab) => {
        const isActive = tab.path === '/course' 
          ? isCourseActive 
          : location.pathname === tab.path || location.pathname.startsWith(tab.path + '/');

        return (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={classNames('tab-item', { active: isActive })}
          >
            <div className="tab-label">{tab.label}</div>
          </NavLink>
        );
      })}
    </div>
  );
};

export default TabBar;
